export default __webpack_public_path__ + "1562553e816c24cd93827043c88be878.png";